module.exports = __webpack_public_path__ + "assets/dbd064c70b454f0d93b2722d5be44e30.svg";